<!--
 * @Author: Jacob.Zhang
 * @Description: 个人信息表 - 主申请人信息
-->
<template>
    <div v-loading="isLoading">
        <Container title="主申请人" padding="0" id="pdf-user-top">
            <div  id="pdf-user-top-score">
            </div>
            <div id="pdf-user">
                <div class="title-box">
                    <span>主申信息</span>
                    <div class="title-btn">
                        <el-button v-if="!isEdit" type="primary" @click="isEdit = true">编辑</el-button>
                        <el-button v-if="isEdit" @click="cancel">取消</el-button>
                        <el-button v-if="isEdit" type="primary" :loading="isLoading" @click="saveInfo">保存</el-button>
                    </div>
                </div>
                <!-- 回显信息 -->
                <UserDetail class="pdf-user-detail" v-if="!isEdit" :info="currentItem" :selectOptions="selectOptions" />
                <!-- 编辑 -->
                <User v-if="isEdit" :ref="user.component" :currentItem.sync="user" :loading.sync="isLoading" :selectOptions="selectOptions" @update="updateDetail" />
            </div>
        </Container>
    </div>
</template>

<script>
import User from './C/EditUser.vue'
import UserDetail from './C/UserDetail.vue'
import { mapState } from 'vuex'
import { getComboList } from '../../../../api/gifted'
export default {
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        },
    },
    components: {
        User, UserDetail,
    },
    created() {
        this.getComboList()
        if(this.info.identity_plan === 0){
            this.info.identity_plan = ''
        }
        if(this.info.approval_unit === 0){
            this.info.approval_unit = ''
        }
        if(this.info.is_incubated === 0){
            this.info.is_incubated = ''
        }
        if(this.info.incubation_status === 0){
            this.info.incubation_status = ''
        }
        this.currentItem = JSON.parse(JSON.stringify(this.info))

        console.log(this.currentItem, 'currentItem')
        this.$store.dispatch('previewPdfGifted/setStateKeyData', { key: 'user', data: JSON.parse(JSON.stringify(this.info)) })
    },
    computed: {
        ...mapState('gifted', ['dataList']),
        ...mapState('previewPdfGifted', ['user'])
    },
    data() {
        return {
            isLoading: false,
            isEdit: false,
            selectOptions: {
                identity_plan: [],
                income_category: [],
                income_detail_type: [],
                approval_unit: [],
                exam_types: [],
                is_incubated:[
                    { label: '是', value: 1 },
                    { label: '否', value: 2 },
                ],
                incubation_status: [],
                incubation_project: [],
                incubation_bottleneck: [],
            },
            currentItem: {}, // 主申人信息（编辑&回显共用）
        }
    },
    methods: {

        async getComboList() {
            const res = await getComboList()
            if(res && res.code === 200) {
                const {
                    approval_unit,
                    exam_types,
                    gaochai_incubation_status,
                    identity_plan,
                    income_categories,
                    income_detail_types,
                    incubation_bottlenecks,
                    youcai_incubation_projects,
                } = res.data
                this.selectOptions.approval_unit = approval_unit || []
                this.selectOptions.exam_types = exam_types || []
                this.selectOptions.incubation_status = gaochai_incubation_status || []
                this.selectOptions.identity_plan = identity_plan || []
                this.selectOptions.income_category = income_categories || []
                this.selectOptions.income_detail_type = income_detail_types || []
                this.selectOptions.incubation_bottleneck = incubation_bottlenecks || []
                this.selectOptions.incubation_project = youcai_incubation_projects || []
            }
        },

        saveInfo() {
            this.$refs[this.info.component].checkInfo()
        },
        // 更新
        updateDetail() {
            this.currentItem = JSON.parse(JSON.stringify(this.user))
            this.isEdit = false
            // 清空标红
            this.$utils.emptyModuleRed(this, 'pdf-bg1')
        },
        // 取消
        cancel() {
            this.currentItem = JSON.parse(JSON.stringify(this.info))
            this.$store.dispatch('previewPdfGifted/setStateKeyData', { key: 'user', data: JSON.parse(JSON.stringify(this.info)) })
            this.isEdit = false
            // 清空标红
            this.$utils.emptyModuleRed(this, 'pdf-bg1')
        }
    }
}
</script>

<style lang="less" scoped>

</style>
